import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  en: require("./lang/en.json"),
  ro: require("./lang/ro.json")
};

export const i18n = new VueI18n({
  locale: "ro", // set locale
  fallbackLocale: "ro", // set fallback locale
  messages // set locale messages
});
